import React, {useEffect, useState} from "react"
export default function DateOfDay(prop){
	const jours = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi","Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi"];
	const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Decembre"];
	const [date, setDate] = useState("")
    const [time, setTime] = useState("")
	const loadDate = () => {
		const newDate = new Date()
		const minute = newDate.getMinutes()
		const hour = newDate.getHours()
		const day = newDate.getDate()
		setTime((hour < 10 ? "0" : "" ) + hour + ":" + (minute < 10 ? "0" : "" ) + minute)
		setDate(jours[newDate.getDay()] + " " + (day < 10 ? "0" : "" ) + day  + " " + months[newDate.getMonth()] + " " + newDate.getFullYear())
	}
    useEffect(() => {	
		loadDate()
		setInterval(
			() => {
				loadDate()
			},10000
		);
    }, [])
	return(
		<div id="day" className="flex column center">
			<div id="hour">
				{time}
			</div>
			<div id="date">
				{date}
			</div>
		</div>
	)
}
    